import { useTranslation } from "react-i18next";

import React from "react";
import { CONTENT_MANAGEMENT_ID, SelectFormField } from "@duosoftbg/nacid-components";

const SelectServices = ({ fieldName, labelCode }) => {
  const { t } = useTranslation();
  return (
    <SelectFormField
      addEmptyOption={false}
      selectOptions={[
        {
          value: CONTENT_MANAGEMENT_ID.SD_HIGHER_EDUCATION_RECOGNITION,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_HIGHER_EDUCATION_RECOGNITION}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_DOCTORATE_DEGREES_DOCTOR,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_DOCTORATE_DEGREES_DOCTOR}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_DOCTORATE_DEGREES_DOCTOR_OF_SCIENCE,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_DOCTORATE_DEGREES_DOCTOR_OF_SCIENCE}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_UNI_CHECKS_ACADEMIC_STATUS,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_UNI_CHECKS_ACADEMIC_STATUS}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_UNI_CHECKS_DOCUMENT_AUTHENTICITY,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_UNI_CHECKS_DOCUMENT_AUTHENTICITY}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_UNI_CHECKS_ISSUE_RECOMMENDATION,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_UNI_CHECKS_ISSUE_RECOMMENDATION}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_NON_REGULATED_PROFESSIONS,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_NON_REGULATED_PROFESSIONS}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_PUBLIC_ACCESS,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_PUBLIC_ACCESS}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_SUGGESTION,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_SUGGESTION}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_SIGNAL,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_SIGNAL}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_OFFICIAL_NOTES_RESEARCH_PROJECT,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_OFFICIAL_NOTES_RESEARCH_PROJECT}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_OFFICIAL_NOTES_SCIENTIFIC_PAPER,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_OFFICIAL_NOTES_SCIENTIFIC_PAPER}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_OFFICIAL_NOTES_DISSERTATION_THESIS,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_OFFICIAL_NOTES_DISSERTATION_THESIS}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_OFFICIAL_NOTES_ACADEMIC_POSITION,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_OFFICIAL_NOTES_ACADEMIC_POSITION}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_INQUIRY_IMPACT_FACTOR,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_INQUIRY_IMPACT_FACTOR}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_INQUIRY_PUBLICATION_CITINGS,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_INQUIRY_PUBLICATION_CITINGS}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_ANALYTIC_PRODUCTS,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_ANALYTIC_PRODUCTS}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_BIBLIOGRAPHIC_REFERENCES_NACID_DBS,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_BIBLIOGRAPHIC_REFERENCES_NACID_DBS}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_BIBLIOGRAPHIC_REFERENCES_FOREIGN_DBS,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_BIBLIOGRAPHIC_REFERENCES_FOREIGN_DBS}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_DOCUMENT_DELIVERY_LIBRARIES,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_DOCUMENT_DELIVERY_LIBRARIES}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_DOCUMENT_DELIVERY_NACID,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_DOCUMENT_DELIVERY_NACID}`),
        },
        {
          value: CONTENT_MANAGEMENT_ID.SD_AR_UNI_ENTRY_REQUEST,
          text: t(`m.${CONTENT_MANAGEMENT_ID.SD_AR_UNI_ENTRY_REQUEST}`),
        },
      ]}
      required={true}
      fieldName={fieldName}
      labelCode={labelCode}
    />
  );
};

export default SelectServices;
